import { Stack } from '@mui/material';

import { useOriginClick } from 'services/datalayer/browse';
import { FeaturedItemFragment } from 'types/api/dato-operations.types';

import FeaturedCard from 'components/@featured-items/FeaturedCard';
import ScrollableList from 'components/@lists/ScrollableList';

interface Props {
  featuredItems?: Array<FeaturedItemFragment>;
}

/**
 * HomeFeaturedItems - Displays the featured section on homepage
 *
 * Shows featured events, collections, and pages in a unified system
 */
const HomeFeaturedItems = ({ featuredItems }: Props) => {
  const handleClick = useOriginClick('Featured', 'Discover');

  if (!featuredItems?.length) {
    return null;
  }

  return (
    <Stack
      sx={{
        mt: { md: 5 },
        mb: { xs: 3, md: 5 },
      }}
    >
      <ScrollableList minWidthItem={{ xs: 220, md: 272 }} imageRefHeight={484}>
        {featuredItems.map((featuredItem, idx) => (
          <FeaturedCard
            key={featuredItem.id}
            featuredItem={featuredItem}
            priority={idx < 5}
            onClick={handleClick}
          />
        ))}
      </ScrollableList>
    </Stack>
  );
};

export default HomeFeaturedItems;
